var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeadlightOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 504.446 504.446",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M251.643,74.961h-0.839c-82.256,0-159.475,28.538-206.479,74.702C14.948,179.879-1,214.292-1,251.223 c0,96.525,113.311,176.262,252.643,176.262c3.357,0,7.554-2.518,8.393-5.875c33.574-111.633,33.574-229.141,0-340.774 C258.357,77.479,255,74.961,251.643,74.961z M245.767,411.538c-127.58-2.518-229.98-73.023-229.98-159.475 c0-31.895,14.269-62.951,41.128-89.81c42.807-43.646,113.311-69.666,188.852-70.505 C275.984,196.666,275.984,306.62,245.767,411.538z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.052,200.862H310.397c-5.036,0-8.393,3.357-8.393,8.393s3.357,8.393,8.393,8.393h184.656 c5.036,0,8.393-3.357,8.393-8.393S500.088,200.862,495.052,200.862z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.052,284.797H310.397c-5.036,0-8.393,3.357-8.393,8.393s3.357,8.393,8.393,8.393h184.656 c5.036,0,8.393-3.357,8.393-8.393S500.088,284.797,495.052,284.797z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.052,368.731H310.397c-5.036,0-8.393,3.357-8.393,8.393c0,5.036,3.357,8.393,8.393,8.393h184.656 c5.036,0,8.393-3.357,8.393-8.393C503.446,372.089,500.088,368.731,495.052,368.731z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.397,133.715h184.656c5.036,0,8.393-3.357,8.393-8.393c0-5.036-3.357-8.393-8.393-8.393H310.397 c-5.036,0-8.393,3.357-8.393,8.393C302.003,130.357,305.361,133.715,310.397,133.715z"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadlightOff);
export default __webpack_public_path__ + "static/media/headlight_off.0c61d2acb0c529abb757912c92451dbd.svg";
export { ForwardRef as ReactComponent };